import { FormikStringSchema, useFieldHelpers } from '@/base'
import { Toggle, ToggleProps } from '@/ui'

export const FormToggle = ({
  name,
  schema,
  value,
  deselectValue,
  multiSelect,
  onClick,
  ...rest
}: Omit<ToggleProps, 'checked' | 'onCheckedChange' | 'value'> & {
  name: string
  value: string | boolean // What value is when selected (not current selected state)
  deselectValue?: string | boolean // What value is when toggled
  schema?: FormikStringSchema
  onClick?: () => void
  multiSelect?: boolean
}) => {
  const { field, helpers } = useFieldHelpers({ name, schema })

  const selected = multiSelect
    ? Array.isArray(field.value) && field.value.includes(value)
    : field.value === value

  return (
    <Toggle
      {...rest}
      checked={selected}
      onClick={async () => {
        if (multiSelect) {
          const newValue = Array.isArray(field.value) ? [...field.value] : []
          if (!selected) {
            newValue.push(value)
          } else {
            newValue.splice(newValue.indexOf(value), 1)
          }

          await helpers.setValue(newValue)
        } else {
          await helpers.setValue(
            //in order to allow the button to act as a true toggle, set the value to the deselected value if one is provided
            deselectValue !== undefined && selected ? deselectValue : value
          )
        }

        onClick?.()
      }}
    />
  )
}
